import type { ReadingView } from '~/composables/useReadingView'
import { useReadingView } from '~/composables/useReadingView'

export type LawView = ReadingView

export function useLawView() {
  return useReadingView('law-view-stack')
}
